import { Link } from 'react-router-dom'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import {
  FindTherapistWrap,
  FindTherapistInner,
  FindTherapistEyebrow,
  FindTherapistHeadline,
  FindTherapistDescription,
  FindTherapistCTA,
  FindTherapistCardsWrap,
  FindTherapistCardsScroll,
  FindTherapistCard,
  FindTherapistCardImage,
  FindTherapistCardName,
  FindTherapistEmpty,
} from './FindTherapistSectionStyles'

const HEADLINE =
  "There's no substitute for the empathy and expertise of a trusted therapist."
const DESCRIPTION =
  'Reset, heal, and grow with our expert therapists, here to support you at every step. Book your session and start making a positive change today.'
const CTA_TEXT = 'Find a Therapist'
const EYEBROW = 'Therapy & Psychology'

export function FindTherapistSection({ therapists = [] }) {
  const list = Array.isArray(therapists) ? therapists : []

  return (
    <FindTherapistWrap>
      <FindTherapistInner>
        <FindTherapistEyebrow>{EYEBROW}</FindTherapistEyebrow>
        <FindTherapistHeadline>{HEADLINE}</FindTherapistHeadline>
        <FindTherapistDescription>{DESCRIPTION}</FindTherapistDescription>
        <FindTherapistCTA to="/therapy-psychiatry">{CTA_TEXT}</FindTherapistCTA>

        <FindTherapistCardsWrap>
          {list.length > 0 ? (
            <FindTherapistCardsScroll>
              {list.map((person, index) => (
                <FindTherapistCard
                  key={person?.id || person?.slug || index}
                  to={`/mentor/${person?.slug}/events`}
                >
                  <FindTherapistCardImage>
                    <img
                      src={getImageLink(person?.profilePicId)}
                      alt=""
                      loading="lazy"
                    />
                  </FindTherapistCardImage>
                  <FindTherapistCardName>{person?.name}</FindTherapistCardName>
                </FindTherapistCard>
              ))}
            </FindTherapistCardsScroll>
          ) : (
            <FindTherapistEmpty>
              Meet our therapists on the Find a Therapist page.
            </FindTherapistEmpty>
          )}
        </FindTherapistCardsWrap>
      </FindTherapistInner>
    </FindTherapistWrap>
  )
}
